var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypelogostyledefaultstatedefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 36,
    viewBox: "0 0 144 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.527 24.7779L99.1125 4.69077C98.8469 4.0586 98.2274 3.64453 97.5415 3.64453C96.8556 3.64453 96.2361 4.05544 95.9706 4.69077L87.5533 24.7747C87.1898 25.6439 87.5975 26.6396 88.4668 27.0031C89.336 27.3666 90.3316 26.9589 90.6951 26.0896L93.483 19.4392H101.597L104.385 26.0928C104.657 26.7471 105.292 27.139 105.956 27.139C106.174 27.139 106.398 27.0979 106.613 27.0063C107.482 26.6428 107.89 25.6439 107.527 24.7779ZM94.9117 16.035L97.5415 9.75759L100.171 16.035H94.9117Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.247 27.3223C111.201 27.3223 110.354 26.4752 110.354 25.4289V10.7469C110.354 9.70062 111.201 8.85352 112.247 8.85352C113.294 8.85352 114.141 9.70062 114.141 10.7469V25.4289C114.141 26.4752 113.294 27.3223 112.247 27.3223Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.033 33.2869C126.033 33.682 126.362 34.0012 126.77 34.0012C126.95 34.0012 127.158 33.8906 127.31 33.78L127.332 33.7642L136.315 26.5828L127.392 18.0264C126.842 17.5807 126.024 17.9726 126.024 18.51V24.0067C126.024 24.8095 125.202 24.9549 124.608 24.7179L123.021 24.1331C122.961 24.111 122.901 24.0857 122.85 24.0478C122.433 23.757 122.256 23.2544 122.256 22.815V6.95081C122.256 5.94566 123.072 5.13017 124.077 5.13017H132.646C135.016 5.14281 138.525 6.98874 138.525 11.0314C138.525 11.809 138.424 12.8458 138.259 13.4242C137.912 14.6474 137.286 15.5736 136.729 16.0793C135.13 17.5333 133.325 17.5491 132.725 17.5143L132.352 17.5048L139.413 24.0383C141.951 21.3073 143.434 17.6249 143.216 13.6012C142.824 6.41979 136.919 0.550116 129.561 0.038061C125.989 -0.211645 122.664 0.780857 119.99 2.6173C118.476 3.65722 117.606 5.37355 117.606 7.17839V21.6044C117.606 23.4188 118.498 25.1319 120.021 26.175C121.614 27.2623 123.116 28.002 125.082 28.4097C125.692 28.5362 126.011 28.9313 126.011 29.7815",
    fill: "url(#paint0_linear_237_8853)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.592 13.544C132.769 13.544 133.388 13.4713 133.809 13.0762C134.128 12.7791 134.371 12.2892 134.371 11.5243C134.371 9.60247 133.328 9.15047 132.449 9.10938H126.697C126.232 9.10938 125.856 9.48551 125.856 9.95016V12.7064C125.856 13.171 126.232 13.5472 126.697 13.5472H132.386L132.589 13.5409L132.592 13.544Z",
    fill: "url(#paint1_linear_237_8853)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0799 4.35254V15.858H8.19722V7.22258H1V4.35254H11.0799Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86651 12.4883V19.1829H11.0799V22.0625H1V19.1829H3.98699V12.4883H6.86967H6.86651Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6366 3.43555V9.43797H20.594V12.3207H16.6366V27.1197H13.7539V3.43555H16.6366Z",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2062 3.43555V9.43797H85.1635V12.3207H81.2062V27.1197H78.3267V3.43555H81.2062Z",
    fill: "#212121"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8104 4.29248C67.618 4.29248 65.0166 6.89069 65.0166 10.0863C65.0166 13.2819 67.6148 15.8801 70.8104 15.8801C74.006 15.8801 76.6042 13.2819 76.6042 10.0863C76.6042 6.89069 74.006 4.29248 70.8104 4.29248ZM70.8104 13.0006C69.2015 13.0006 67.893 11.692 67.893 10.0831C67.893 8.47427 69.2015 7.16568 70.8104 7.16568C72.4193 7.16568 73.7279 8.47427 73.7279 10.0831C73.7279 11.692 72.4193 13.0006 70.8104 13.0006Z",
    fill: "#212121"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8411 4.36498V7.23818H52.2626V12.915H60.8411V15.8009H56.6688V19.2051H60.8411V22.0909H49.3799V19.2051H53.7861V15.8009H49.3799V4.36182H60.8411V4.36498Z",
    fill: "#212121"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1357 24.1362C51.8895 24.1362 49.2471 26.7787 49.2471 30.0249C49.2471 33.271 51.8895 35.9167 55.1357 35.9167C58.3819 35.9167 61.0275 33.2742 61.0275 30.0249C61.0275 26.7755 58.385 24.1362 55.1357 24.1362ZM55.1357 33.0277C53.4794 33.0277 52.1329 31.6811 52.1329 30.0249C52.1329 28.3686 53.4794 27.0221 55.1357 27.0221C56.792 27.0221 58.1385 28.3686 58.1385 30.0249C58.1385 31.6811 56.792 33.0277 55.1357 33.0277Z",
    fill: "#212121"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 3.43262V6.04663H26.7451V3.43262H33.0921Z",
    fill: "#212121"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2262 3.43555V9.43797H44.1867V12.3207H40.2262V24.2497H43.9844V35.7488H41.1018V27.1165H33.9014V24.2497H37.3467V3.43555H40.223H40.2262Z",
    fill: "#212121"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3552 7.29199H24.3555V10.023H25.2784L25.2405 10.1146C24.9813 10.7247 24.8454 11.4042 24.8454 12.0807C24.8454 14.8464 27.0959 17.0969 29.8616 17.0969C32.6274 17.0969 34.8779 14.8464 34.8779 12.0807C34.8779 11.4011 34.742 10.7405 34.4765 10.1146L34.4385 10.023H35.3615V7.29199H35.3552ZM29.8585 14.3027C28.6321 14.3027 27.6333 13.3039 27.6333 12.0775C27.6333 10.8511 28.6321 9.84911 29.8585 9.84911C31.0849 9.84911 32.0837 10.8479 32.0837 12.0775C32.0837 13.3071 31.0849 14.3027 29.8585 14.3027Z",
    fill: "#212121"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.488 4.16889C114.488 5.42374 113.483 6.44153 112.244 6.44153C111.005 6.44153 110 5.42374 110 4.16889C110 2.91404 111.005 1.89941 112.244 1.89941C113.483 1.89941 114.488 2.9172 114.488 4.16889Z",
    fill: "url(#paint2_linear_237_8853)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_237_8853",
    x1: 114.917,
    y1: 1.34349,
    x2: 138.522,
    y2: 24.9486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5143E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_237_8853",
    x1: 124.962,
    y1: 9.28473,
    x2: 127.059,
    y2: 14.6227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5143E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_237_8853",
    x1: 109.529,
    y1: 2.07889,
    x2: 112.57,
    y2: 6.06564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5143E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypelogostyledefaultstatedefault);
export default __webpack_public_path__ + "static/media/type=logo, style=default, state=default.5bfb72159ce5434cdecee36c7801d442.svg";
export { ForwardRef as ReactComponent };